import restMenus from "../_ApiConn/apiRestMenus";


const getRestMenu = async () => {
    const token = 'innerToken';
    let dFromF = await restMenus.getRestMenu({ token });
    return (dFromF);
}



const getOnlySections = async () => {
    const token = 'innerToken';
    let dFromF = await restMenus.getOnlySections({ token });
    return (dFromF);
}


const findProductById = async (prodId) => {
    const token = 'innerToken';
    let dFromF = await restMenus.findProductById({ token, prodId });
    return (dFromF);
}

const getSectionsDetails = async (itemsOfSection) => {
    let dFromF = await restMenus.getSectionsDetails(itemsOfSection);
    return (dFromF);
}
// const getMnuByRestId = async (restId) => {
//     const token = localStorage.getItem('token');
//     let dFromF = await restMenus.getMnuByRestId({token,restId});
//     return (dFromF);
// }

// const createRestMnu = async (obj) => {
//     let dFromF = await restMenus.createRestMnu(obj);
//     return (dFromF);
// }


// const removeFromMenus = async (id) => {
//     let dFromF = await restMenus.removeFromMenus(id);
//     return (dFromF);
// }

export default {
    getRestMenu,
    getOnlySections,
    findProductById,
    getSectionsDetails
    // getMnuByRestId,
    // createRestMnu,
    // removeFromMenus
};